import React, { Component } from "react";
import { connect } from "react-redux";
import { professionalAction } from "../../_actions";
import {
  Input,
  message,
  PageHeader,
  Switch,
  Table,
  Button,
  Row,
  Col,
  Modal,
  Space,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { LanguageContext } from "../../context/LanguageContext";
import { adminService } from "../../_services/admin.service";
import { Select } from "antd";
import { ViewFormModel } from "../ProfessionalForm/ViewForm/ViewFormModel";
import * as XLSX from "xlsx-js-style";
import moment from "moment";
import _ from "lodash";
const { Option } = Select;

class CrimeNullList extends Component {
  static contextType = LanguageContext;
  state = {
    data: [],
    cityId: [],
    loading: false,
    searchText: "",
    pagination: {
      current: 1,
      pageSize: 10,
    },
    setCriminalViewModel: false,
    states: [],
    cities: [],
    selected_state: "",
  };

  getcrimeNullList = () => {
    this.setState({
      loading: true,
    });
    adminService.crimeNullList({ cityId: this.state.cityId }).then((res) => {
      console.log("res", res);
      this.setState({
        data: res.results,
        loading: false,
      });
    });
  };

  getCountry = () => {
    this.setState({
      loading: true,
    });
    professionalAction.getCountry().then((res) => {
      this.setState({
        states: res.pc_countrystates,
        loading: false,
      });
    });
  };

  getStatesWiseCityData = (id) => {
    professionalAction.getStatesWiseCityData(id).then((res) => {
      this.setState({
        cities: res.pc_citiesData,
      });
    });
  };
  componentDidMount() {
    this.props.dispatch(professionalAction.getAllMaster());
    this.props.dispatch(professionalAction.getCity());

    this.props.dispatch(professionalAction.getDharm());
    this.props.dispatch(professionalAction.getKalam());
    this.props.dispatch(professionalAction.getKayda());
    this.props.dispatch(professionalAction.getCrimeType());
    this.props.dispatch(professionalAction.getCrimeTitle());
    this.props.dispatch(professionalAction.getStatus());
    this.getCountry();
  }
  showCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: true,
    });
  };

  closeCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: false,
    });
  };

  onViewAccusedForm = (data) => {
    if (data) {
      this.showCriminalViewModel();
      this.props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  downloadExcel = () => {
    const { t, language } = this.context;

    const report_name = "crimeNull Report";
    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;

    let ReportTitle = "Registered Cases – Crime Null Report";

    let list = [];
    const data = this.state.data;
    console.log("data", data);
    list =
      data &&
      data.map((data, index) => ({
        [t("sr.no")]: index + 1,
        "CMIS ID": data.masterId,
        [t("accused_name")]: data.name ? data.name : "-",
        [t("address")]: data.address ? data.address : "-",
        [t("accused_police_station")]: data.districtName,
      }));
    console.log("final list", list);

    var arrData = list;
    console.log("arrData", arrData);

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    console.log("this props.user", this.props.user);
    const cityIds = Array.isArray(this.state.cityId)
      ? this.state.cityId
      : this.state.cityId
        ? [this.state.cityId]
        : [];
    const cityName = cityIds
      .map((id) => this.getCityName(id))
      .filter(Boolean)
      .join(", ");
    console.log("cityName", cityName);
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData = `${cityName}`;

    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: ReportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] = {
      v: `${
        moment(this.state.report_4_startDate).format("DD-MM-YYYY") || "-"
      } `,
      t: "s",
    };

    ws["A3"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
      { s: { r: 2, c: 0 }, e: { r: 2, c: columnWidths.length - 1 } },
    ];

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  handleTableChange = (pagination) => {
    this.setState({
      pagination: {
        ...this.state.pagination,
        current: pagination.current,
        pageSize: pagination.pageSize,
      },
    });
  };
  render() {
    const { loading, searchText, pagination, data ,cities} = this.state;
    const { professionals } = this.props;
    console.log("professional", professionals);
    const { t } = this.context;
    const columns = [
      {
        title: t("sr.no"),
        dataIndex: "srNo",
        key: "srNo",
        render: (_, __, rowIndex) =>
          (pagination.current - 1) * pagination.pageSize + rowIndex + 1,
      },
      {
        title: t("accused_name"),
        dataIndex: "name",
        key: "name",
        render: (text, record) => (
          <Space
            size="middle"
            title={record.masterId ? record?.masterId : record.id}
          >
            {record?.name}
          </Space>
        ),
      },
      {
        title: t("address"),
        dataIndex: "address",
        key: "address",
      },
      {
        title: t("accused_police_station"),
        dataIndex: "districtName",
        key: "districtName",
      },
      {
        title: "action",
        dataIndex: "action",
        key: "action",
        render: (text, record) => (
          <Button
            type="primary"
            onClick={() => this.onViewAccusedForm(record.masterId)}
          >
            {t("view1")}
          </Button>
        ),
      },
    ];
    return (
      <>
        <div
          className="site-page-header-ghost-wrapper"
          style={{
            padding: "20px",
            background: "#fff",
            marginBottom: "20px",
          }}
        >
          <PageHeader>Profile with Zero crime</PageHeader>
          <div style={{ marginBottom: 16 }}>
            <Row gutter={16} align="middle" style={{ marginBottom: 16 }}>
              <Col>
                <Select
                  value={this.state.selected_state}
                  onChange={(value) => {
                    this.setState({ selected_state: value, cityId: [] }, () => {
                      if (value) {
                        this.getStatesWiseCityData(value);
                      }
                    });
                  }}
                  placeholder="Select State"
                  style={{ width: 250 }}
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.children
                      ?.toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {this.state.states.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.state}
                    </Option>
                  ))}
                </Select>
              </Col>
              {this.state.selected_state && (
                <Col>
                  <Select
                    mode="multiple"
                    value={this.state.cityId}
                    onChange={(value) => this.setState({ cityId: value || [] })}
                    placeholder="Select City"
                    style={{ width: 250 }}
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    maxTagCount={2}
                    filterOption={(input, option) =>
                      option?.children
                        ?.toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {cities?.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.City}
                      </Option>
                    ))}
                  </Select>
                </Col>
              )}

              <Col>
                <Button
                  type="primary"
                  onClick={this.getcrimeNullList}
                  disabled={!this.state.cityId?.length}
                >
                  Find
                </Button>
              </Col>

              <Col>
                <Button
                  disabled={
                    !this.state.cityId?.length &&
                    (!this.state.data || this.state.data.length === 0)
                  }
                  onClick={() =>
                    this.setState({
                      cityId: [],
                      data: [],
                    })
                  }
                >
                  Reset
                </Button>
              </Col>

              {/* Download Excel - Right Side */}
              <Col style={{ marginLeft: "auto" }}>
                <Button
                  type="primary"
                  onClick={this.downloadExcel}
                  disabled={!this.state.data || this.state.data.length === 0}
                >
                  Download Excel
                </Button>
              </Col>
            </Row>
          </div>

          <Row justify="end" style={{ marginBottom: 12 }}>
            <Col>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "6px 14px",
                  background: "#6f42c1",
                  borderRadius: 6,
                  boxShadow: "0 2px 6px rgba(111, 66, 193, 0.25)",
                }}
              >
                <span style={{ fontSize: 13, color: "#fff" }}>
                  {t("total")}:
                </span>
                <strong style={{ fontSize: 16, color: "#fff" }}>
                  {data.length}
                </strong>
              </div>
            </Col>
          </Row>

          <Table
            bordered
            loading={loading}
            scroll={{ x: "max-content" }}
            columns={columns}
            dataSource={data}
            rowKey="id"
            rowClassName={() => "govt-table-row"}
            pagination={{
              ...pagination,
              total: data.length,
              showTotal: (total) => `Total ${total} states`,
            }}
            onChange={this.handleTableChange}
          />
          <Modal
            title="आरोपी प्रोफाइल"
            top
            visible={this.state.setCriminalViewModel}
            onOk={this.closeCriminalViewModel}
            onCancel={this.closeCriminalViewModel}
            width={95 + "%"}
          >
            <ViewFormModel
              key={this.props && this.props.user.id}
              dataStates={this.props.professionals}
              preventiveAction={this.state.preventiveAction}
            ></ViewFormModel>
          </Modal>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedCountryStates = connect(mapStateToProps)(CrimeNullList);
export { connectedCountryStates as CrimeNullList };
